import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Modal } from 'ui-components/components/modal';
import { ModalBody } from 'ui-components/components/modal/modal-body';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { withGuard } from 'ui-components/components/with-guard';
import { ModalPortal } from '../../../../modal-portal';
import { useImportContext } from '../import-context';
import { MappingTemplatesTable } from './mapping-templates-table';
import { messages } from './messages';
import styles from './styles.module.css';

export const MappingManagementModal = withGuard(({ onClose }) => {
  const { mappingList } = useImportContext();

  return (
    <ModalPortal onClose={onClose}>
      <Modal>
        <ModalHeader>
          <FormattedMessage {...messages.manageTemplatesModalTitle} />
        </ModalHeader>
        <ModalBody className={styles['modal-body']}>
          {mappingList?.length ? (
            <>
              <FormattedMessage {...messages.manageTemplatesModalBodyMessage} />
              <MappingTemplatesTable />
            </>
          ) : (
            <FormattedMessage {...messages.manageTemplatesModalNoTemplates} />
          )}
        </ModalBody>
      </Modal>
    </ModalPortal>
  );
});

MappingManagementModal.propTypes = {
  onClose: PropTypes.func.isRequired,
};
